export function deliveryQuote(total, region = 'standard') {
  if (!Number.isSafeInteger(total) || total < 0) return null;
  let fee;
  let threshold;
  if (region === 'pickup') return { fee: 0, total, gap: 0 };
  if (region === 'lantau') {
    threshold = 50000;
    fee = total >= threshold ? 0 : 25000;
  } else if (region === 'discovery') {
    threshold = 80001;
    fee = total >= threshold ? 0 : 25000;
  } else {
    threshold = 100000;
    fee = total >= 100000 ? 0 : total >= 75000 ? 10000 : total >= 50000 ? 20000 : 25000;
  }
  return { fee, total: total + fee, gap: Math.max(0, threshold - total) };
}

if (typeof document !== 'undefined' && !customElements.get('gp-cart-estimate')) {
  const storageKey = 'gp-delivery-region-v1';
  let region = '';
  try { region = localStorage.getItem(storageKey) || ''; } catch {}
  if (!['', 'standard', 'lantau', 'discovery', 'pickup'].includes(region)) region = '';
  const money = cents => `HK$${(cents / 100).toLocaleString('en-HK', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 })}`;
  const put = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };

  class CartEstimate extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('hdt-main-cart, hdt-cart-drawer');
      this.copy = JSON.parse(this.querySelector('[data-gp-estimate-copy]').textContent);
      this.abort = new AbortController();
      this.locks = new Map();
      const options = { signal: this.abort.signal };
      this.querySelector('select').addEventListener('change', event => {
        region = event.target.value;
        try { localStorage.setItem(storageKey, region); } catch {}
        document.querySelectorAll('gp-cart-estimate').forEach(el => el.render());
        document.dispatchEvent(new CustomEvent('gp:delivery-region'));
      }, options);
      document.addEventListener('theme:loading:doing', () => { this.loading = true; this.syncBusy(); }, options);
      document.addEventListener('theme:loading:done', () => { this.loading = false; this.syncBusy(); }, options);
      this.observer = new MutationObserver(() => this.syncBusy());
      this.observer.observe(this.scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
      this.render();
      this.syncBusy();
    }
    disconnectedCallback() {
      this.abort.abort();
      this.observer.disconnect();
      this.locks.forEach((wasDisabled, button) => { if (button.isConnected) button.disabled = wasDisabled; });
    }
    render() {
      const eligible = this.dataset.eligible === 'true';
      this.scope.classList.toggle('gp-estimate-active', eligible);
      this.scope.classList.toggle('gp-pickup-estimate', eligible && region === 'pickup');
      if (!eligible) return;
      const q = deliveryQuote(Number(this.dataset.total), region);
      if (!q) return;
      this.querySelector('select').value = region;
      this.querySelector('select').disabled = false;
      this.dataset.gap = q.gap;
      this.dataset.region = region;
      put(this.querySelector('[data-gp-fee]'), q.fee ? money(q.fee) : this.copy.free);
      put(this.querySelector('[data-gp-gap]'), region === 'pickup' ? '' : q.gap ? this.copy.gap.replace('{amount}', money(q.gap)).replace('{saving}', money(q.fee)) : this.copy.qualified);
      put(this.querySelector('[data-gp-caveat]'), region === 'pickup' ? this.copy.pickup : this.copy.caveat);
      this.querySelector('[data-gp-eta]').hidden = region === 'pickup';
      this.scope.querySelectorAll('[data-gp-checkout-total]').forEach(el => put(el, money(q.total)));
      this.scope.querySelectorAll('[data-gp-checkout-label]').forEach(el => put(el, this.copy.estimate));
    }
    syncBusy() {
      if (!this.isConnected) return;
      const busy = !!this.loading || !!this.scope.querySelector('.cart-items-disabled');
      this.scope.querySelectorAll('button[name="checkout"]').forEach(button => {
        if (busy && !this.locks.has(button)) { this.locks.set(button, button.disabled); button.disabled = true; }
        if (!busy && this.locks.has(button)) { button.disabled = this.locks.get(button); this.locks.delete(button); }
        button.setAttribute('aria-busy', String(busy));
      });
      this.scope.querySelectorAll('[data-gp-cart-status]').forEach(el => put(el, busy ? this.copy.updating : ''));
    }
  }
  customElements.define('gp-cart-estimate', CartEstimate);
}
